export interface IRoleSkillTool {
  id: number;
  name: string;
  description: string | null;
  created_at: string;
  updated_at: string;
  created_by: string | null;
  last_updated_by: string | null;
};

export type RateCardRateType =
  | "hourly"
  | "stream"
  | "daily"
  | "salaried"
  | "fixed";

export const RATE_CARD_RATE_TYPES: RateCardRateType[] = [
  "hourly",
  "stream",
  "daily",
  "salaried",
  "fixed",
];

export type RateCardCurrency = "USD" | "ZWG";

export const RATE_CARD_CURRENCIES: RateCardCurrency[] = ["USD", "ZWG"];

export interface IRateValue {
  amount?: number | null;
  currency?: string | null;
  overtime_multiplier?: number | null;
  night_premium?: number | null;
  notes?: string | null;
}

export type IRateDetails = Partial<Record<RateCardRateType, IRateValue | null>>;

export interface IRateCardProps {
  id: number;
  role: IRoleSkillTool;
  role_id: number | null;
  rate: IRateDetails | null;
  currency: string | null;
  effective_date: string;
  rating_type: string;
  created_at: string | null;
  updated_at: string | number;
  created_by: string | null;
  last_updated_by: string | null;
};

export interface ICreateRateDialogProps {
  formData: IFormProps;
  formLoading: boolean;
  handleCreateRate: () => void;
  handleInputChange: (name: string, value: string) => void;
  handleRolesChange: (role: string | null) => void;
  setDialogOpen: (open: boolean) => void;
  open: boolean;
  rateType: RateCardRateType;
  resetForm: () => void;
  selectedRoles: string | undefined;
  setSelectedRoles: (role: string | undefined) => void;
  setRateType: (type: RateCardRateType) => void;
};

export const getRateAmount = (
  rate: IRateDetails | null | undefined,
  rateType: RateCardRateType,
) => {
  const amount = rate?.[rateType]?.amount;

  if (typeof amount === "number") {
    return amount;
  }

  const normalizedAmount = Number(amount ?? 0);

  return Number.isFinite(normalizedAmount) ? normalizedAmount : 0;
};

export const isRateCardRateType = (
  value: string | null | undefined,
): value is RateCardRateType =>
  !!value && RATE_CARD_RATE_TYPES.includes(value as RateCardRateType);

export interface IFormProps {
  role: {
    name: string;
    description: string | null;
  };
  hourly_rate: number;
  stream_rate: number;
  daily_rate: number;
  salaried_rate: number;
  fixed_rate: number;
  roleId: number | null;
  currency: RateCardCurrency;
  effective_date: string;
  last_updated_by: string | null;
};

export interface IEditRateDialogProps {
  formData: IFormProps;
  formLoading: boolean;
  handleEditRate: () => void;
  handleInputChange: (name: string, value: string) => void;
  handleRolesEdit: (role: string | null) => void;
  setDialogOpen: (open: boolean) => void;
  open: boolean;
  rateType: RateCardRateType;
  resetForm: () => void;
  selectedRateCard: IRateCardProps | null;
  selectedRoles: string | undefined;
  setSelectedRoles: (role: string | undefined) => void;
  setRateType: (type: RateCardRateType) => void;
};
